import React, { Component } from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import { media } from "../../../constants/theme";
import { RichText } from "prismic-reactjs";
import { PageWrapper } from "../../components/page-wrapper";
import { Footer } from "../../components/footer";
import { Inner } from "../../atoms/inner";
import { fetchPerson } from "../../../store/thunks/person";

const ContentWrapper = styled.div`
  max-width: 600px;
  margin: 0 auto;
  position: relative;
  bottom: 70px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  p {
    margin-bottom: 30px;
    margin-top: 0;
    font-size: 18px;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.86);
    font-weight: 300;
  }

  ${media.tablet`
    bottom: 0;    
  `}
`;

const ContentHeader = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    font-size: 30px;
    font-weight: 600;
    font-style: italic;
    margin-bottom: 10px;
  }

  ${media.tablet`
    flex-direction:row;
    margin-top: 40px; 
    display:flex;
    flex-direction: row; 
    align-items:center;
    justify-content:center;   
  `}
`;

const PersonImage = styled.img`
  margin-bottom: 20px;

  ${media.tablet`
    max-width: 300px;
    border-radius: 5px;
  `}
`;

const RemoteSince = styled.p`
  font-size: 13px;
  letter-spacing: 3px;
  text-transform: uppercase;
  font-weight: 400;
  color: #ccc;
  margin-top: 0;

  ${media.tablet`
    font-size: 10px;
  `}
`;

const HeroCopy = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  bottom: 70px;
  border-top: 3px solid #00ffb7;
  padding: 20px 0px;
  width: 350px;
  background-color: #fff;
  ${media.tablet`
    bottom: 0;
    border-top: 0;
  `}
`;

const PersonJobType = styled.p`
  background-color: #00ffb7;
  color: hsla(163, 100%, 20%, 1);
  padding: 6px 16px;
  letter-spacing: 2px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  font-style: italic;
  border-radius: 14px;
  margin-bottom: 20px;

  ${media.tablet`
    font-size: 10px;
  `}
`;

const PersonLinks = styled.div`
  border-top: 2px solid #00ffb7;
  padding-top: 70px;
  display:flex;
  flex-direction:column;
  align-items: center; 
  justify-content:center;

  h2 {
    margin-bottom 20px;
    text-align:center;
    font-weight: 600;
  }  

  p {
    margin-bottom: 0;
  }

  ${media.tablet`
    padding-top:20px;
  `}
`;

const SocialIcons = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 20px;

  svg {
    margin-right: 20px;
  }
`;

const getPersonId = (url) => {
  return url.split("/")[2]; // Return the second part of the URL
};

export class Person extends Component {
  static fetchData(store, url) {
    const personId = getPersonId(url);
    return store.dispatch(fetchPerson(personId));
  }

  shouldComponentUpdate(props) {
    let url = window.location.pathname;
    if (props.person.uid !== getPersonId(url)) {
      window.scrollTo(0, 0);
      this.props.fetchPerson(getPersonId(url));
    }
    return true;
  }

  componentDidMount() {
    let url = window.location.pathname;
    if (this.props.person.uid !== getPersonId(url)) {
      window.scrollTo(0, 0);
      this.props.fetchPerson(getPersonId(url));
    }
  }

  render() {
    const {
      name,
      shortName,
      image,
      questionOne,
      questionTwo,
      questionThree,
      questionFour,
      questionFive,
      questionSix,
      questionSeven,
      questionEight,
      website,
      remoteSince,
      category,
      twitter,
      medium,
      facebook,
      instagram,
      linkedin,
    } = this.props.person;
    return (
      <div>
        <Helmet>
          <title>Remote worker - {name.length > 0 ? name[0].text : ""}</title>
          <meta
            name="description"
            content={`Learn how remote worker ${
              name.length > 0 && name[0].text
            } got started working remotely. Discover what a typical day looks like and learn first hand about the benefits of having a remote job.`}
          />
        </Helmet>
        <PageWrapper>
          <ContentHeader>
            {image && image.url ? <PersonImage src={image.url} /> : null}
            <HeroCopy>
              {name.length > 0 ? RichText.render(name) : null}
              <PersonJobType>
                {category.length > 0 ? category : null}
              </PersonJobType>
              <RemoteSince>
                Remote since{" "}
                {remoteSince.length > 0 ? remoteSince[0].text : null}
              </RemoteSince>
            </HeroCopy>
          </ContentHeader>
          <Inner>
            <ContentWrapper>
              <h2>When did you start remote working?</h2>
              {questionOne.length > 0 ? RichText.render(questionOne) : null}

              <h2>What did you do before you worked remotely?</h2>
              {questionTwo.length > 0 ? RichText.render(questionTwo) : null}

              <h2>What do you do now to support yourself financially?</h2>
              {questionThree.length > 0 ? RichText.render(questionThree) : null}

              <h2>How did you transition to become a remote worker?</h2>
              {questionFour.length > 0 ? RichText.render(questionFour) : null}

              <h2>What's a typical day in your life now?</h2>
              {questionFive.length > 0 ? RichText.render(questionFive) : null}

              <h2>
                What's the thing you enjoy most about being location independent
                and working remotely?
              </h2>
              {questionSix.length > 0 ? RichText.render(questionSix) : null}

              <h2>What are you most looking forward to in the next year?</h2>
              {questionSeven.length > 0 ? RichText.render(questionSeven) : null}

              <h2>
                What is the one thing you would advise to anyone looking to take
                great control of their work life?
              </h2>
              {questionEight.length > 0 ? RichText.render(questionEight) : null}

              <PersonLinks>
                <h2>
                  Discover more from{" "}
                  {shortName.length > 0 ? shortName[0].text : null}
                </h2>
                <SocialIcons>
                  {instagram && instagram.length > 0 ? (
                    <a
                      href={`https://www.instagram.com/${instagram[0].text}`}
                      target="_blank"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                        ></path>
                      </svg>
                    </a>
                  ) : null}
                  {twitter && twitter.length > 0 ? (
                    <a
                      href={`https://www.twitter.com/${twitter[0].text}`}
                      target="_blank"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                        ></path>
                      </svg>
                    </a>
                  ) : null}
                  {linkedin && linkedin.length > 0 ? (
                    <a
                      href={`https://www.linkedin.com/in/${linkedin[0].text}`}
                      target="_blank"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        height="24"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"
                        ></path>
                      </svg>
                    </a>
                  ) : null}
                  {facebook && facebook.length > 0 ? (
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      role="img"
                      height="24"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                    >
                      <path
                        fill="currentColor"
                        d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z"
                      ></path>
                    </svg>
                  ) : null}
                  {medium && medium.length > 0 ? (
                    <a
                      href={`https://www.medium.com/${medium[0].text}`}
                      target="_blank"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                        height="24"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path
                          fill="currentColor"
                          d="M0 32v448h448V32H0zm372.2 106.1l-24 23c-2.1 1.6-3.1 4.2-2.7 6.7v169.3c-.4 2.6.6 5.2 2.7 6.7l23.5 23v5.1h-118V367l24.3-23.6c2.4-2.4 2.4-3.1 2.4-6.7V199.8l-67.6 171.6h-9.1L125 199.8v115c-.7 4.8 1 9.7 4.4 13.2l31.6 38.3v5.1H71.2v-5.1l31.6-38.3c3.4-3.5 4.9-8.4 4.1-13.2v-133c.4-3.7-1-7.3-3.8-9.8L75 138.1V133h87.3l67.4 148L289 133.1h83.2v5z"
                        ></path>
                      </svg>
                    </a>
                  ) : null}
                </SocialIcons>
                {website.length > 0 ? RichText.render(website) : null}
              </PersonLinks>
            </ContentWrapper>
          </Inner>
        </PageWrapper>
        <Footer />
      </div>
    );
  }
}
